/**
 * "Sair da loja?" — aparece quando o cliente aperta o VOLTAR do celular na
 * tela inicial, sem nenhum modal aberto. Quem decide mostrar é
 * `utils/guardaDoVoltar.ts` (evento `aliv:perguntar-saida`).
 *
 * Não registra em `useModalOpen` de propósito: com a pergunta na tela o
 * guarda fica no nível 0, desarmado, e um segundo voltar sai direto —
 * "voltar duas vezes sai", como o cliente espera.
 */
import { useEffect, useState } from 'react';
import { t } from '../i18n';
import { ficarNoApp, sairDoApp } from '../utils/guardaDoVoltar';

export function SairDoAppIsland() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const abrir = () => setVisible(true);
    window.addEventListener('aliv:perguntar-saida', abrir);
    return () => window.removeEventListener('aliv:perguntar-saida', abrir);
  }, []);

  // Saiu pelo voltar do navegador com a pergunta aberta e voltou (bfcache):
  // não reabre a pergunta velha.
  useEffect(() => {
    if (!visible) return;
    const fechar = () => setVisible(false);
    window.addEventListener('pagehide', fechar);
    return () => window.removeEventListener('pagehide', fechar);
  }, [visible]);

  if (!visible) return null;

  function ficar() {
    setVisible(false);
    ficarNoApp();
  }

  function sair() {
    setVisible(false);
    sairDoApp();
  }

  // z acima de qualquer faixa fixa do app (PWA, avisos): a pergunta é a
  // última coisa da tela e os botões ficam na base no celular.
  return (
    <div
      className="fixed inset-0 z-[100001] bg-black/60 flex items-end sm:items-center justify-center p-3"
      onClick={ficar}
    >
      <div
        className="bg-white rounded-2xl w-full sm:w-[400px] p-5 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-red-50 text-red-600 flex items-center justify-center shrink-0">
            <i className="fas fa-door-open" />
          </div>
          <div className="min-w-0">
            <h4 className="font-extrabold text-gray-900 text-base leading-tight">
              {t('Sair da loja?')}
            </h4>
            <p className="text-xs text-gray-500 mt-0.5">
              {t('Sua sacola fica guardada se você voltar depois.')}
            </p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2 mt-2">
          <button
            type="button"
            onClick={ficar}
            className="border border-gray-200 hover:bg-gray-50 text-gray-700 font-bold py-3 rounded-xl text-sm transition"
          >
            {t('Permanecer')}
          </button>
          <button
            type="button"
            onClick={sair}
            className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 rounded-xl text-sm transition"
          >
            {t('Sim, sair')}
          </button>
        </div>
      </div>
    </div>
  );
}
